export default __webpack_public_path__ + "static/GLOSS PRO+ HIGH GLOSS LAMINATE-28351ed4715da63283af6556e3eaa313.webp";